import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import Header from '../components/Header/Header'
import { useSearchConditionsMutation } from '../../../services'
import { UspConfigurationCarConditionViewResult } from '../../../models'
import InventoryConditionsTable from './components/InventoryConditionsTable'
import AddEditConditions from './components/AddEditConditions'
import { Button, Card, Container, Grid } from '@mui/material'
import Iconify from '../../../components/iconify'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'

const SettingsInventoryConditions = () => {
  const [rowData, setRowData] = useState({})
  const [openAddEditModal, setOpenAddEditModal] = useState(false)
  const [type, setType] = useState('')
  const [searchCarConditions, { data, isLoading }] = useSearchConditionsMutation()
  const [carConditionData, setCarConditionData] = useState<UspConfigurationCarConditionViewResult[]>([])

  const handleSubmit = (values?: any) => {
    searchCarConditions({
      uspConfigurationCarConditionView: {
        searchString: values?.searhString,
        isIncludeInactive: values?.isIncludeInactive,
      },
    })
  }

  const handleOpenModal = () => {
    setOpenAddEditModal(true)
    setType('add')
  }

  const handleCloseModal = () => {
    setOpenAddEditModal(false)
  }

  useEffect(() => {
    if (data) {
      setCarConditionData(data)
    }
  }, [data])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='Conditions'
        links={[
          {
            name: 'List',
          },
        ]}
        action={
          <>
            <Button onClick={handleOpenModal} variant='contained' startIcon={<Iconify icon='mingcute:add-line' />}>
              Add new
            </Button>
          </>
        }
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Form onSubmit={handleSubmit} initialValues={{ searhString: null, isIncludeInactive: false }}>
        {({ handleSubmit, form: { submit } }: any) => (
          <>
            <form onSubmit={handleSubmit}>
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Header submit={submit} title='' handleOpenModal={handleOpenModal} />
                  </Grid>
                  <Grid item xs={12}>
                    <InventoryConditionsTable
                      loading={isLoading}
                      data={carConditionData}
                      setData={setCarConditionData}
                      setOpenAddEditModal={setOpenAddEditModal}
                      setType={setType}
                      setRowData={setRowData}
                      handleOpenModal={handleOpenModal}
                    />
                  </Grid>
                </Grid>
              </Card>
            </form>
            <AddEditConditions
              submit={submit}
              open={openAddEditModal}
              onClose={handleCloseModal}
              type={type}
              rowData={rowData as UspConfigurationCarConditionViewResult}
            />
          </>
        )}
      </Form>
    </Container>
  )
}

export default SettingsInventoryConditions
